<!-- 图片上传组件 -->
<template lang="html">
	<div class="avatar_kuang el-upload-list--picture-card">
		<el-upload class="avatar_li" :action="image_up+'admin_base_api/image_up'" :show-file-list="false" :data="datas" :before-upload="before_upload" :on-success="imageSuccess">
			<img :src="img_type_url(value)" v-if="value" class="image">
			<i class="el-icon-plus avatar-uploader-icon" v-else></i>
		</el-upload>
	</div>
</template>
<script>
import Download from  '@/../static/js/download.min';
export default {
	name: 'upload',
	data() {
		return {
			image_up:process.env.API_ROOT,
		}
	},
	props: {
		value: {
			type: String,
			default:'',
		},
		datas: {
			type: Object,
			default:()=>{}
		},
	},
	mounted() {
	},
	methods: {
		before_upload(){
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
		imageSuccess(res,file){
			if (res.status==200) {
				this.$message.success('图片上传成功');
				this.$emit('callback',res.data.image);
			}else{
				this.$message.error(res.message);
			}
			this.loading.close();
		},
        img_type_url(data){
        	if (data) {
				var type_array=['jpg','jpeg','png','gif','bmp','JPG','JPEG','PNG','GIF','BMP'];
				var img_array=data.split('.');
				var img_type=img_array[img_array.length-1];
				if (type_array.indexOf(img_type)==-1) {
					return '@/../static/img/file.png'
				}else if(data.indexOf('http')!=-1){
					return data
				}else{
				    var API_IMGURL = process.env.API_IMG_URL;
					return API_IMGURL+data
				}
        	}
        	return '';
        },
	}
}
</script>
<style lang="css" scoped>

.avatar_kuang{
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}
.avatar_kuang .avatar_li{
	position: relative;
	display: inline-block
}
.avatar_kuang .avatar_li /deep/ .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	display: block;
	width: 100px;
	height: 100px;
	line-height: 100px!important;
	font-size: 28px;
	color: #8c939d;
	text-align: center;
}
.avatar_kuang .avatar_li /deep/ .el-upload .el-upload-dragger{
	width: 100%;
	height: 100%;
}
.avatar_kuang .avatar_li /deep/ .el-upload:hover {
	border-color: #409EFF;
}
.avatar_kuang .avatar_li /deep/ .el-upload .avatar{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.avatar_kuang .avatar_li /deep/ .image{
	border: 1px dashed #d9d9d9;
	width: 100px;
	height: 100px;
	object-fit: contain;
}
.avatar_kuang .avatar_li /deep/ .avatar-uploader-icon {
	width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/upload.vue